import React from 'react';
import { volumes } from '../data/content';
import { CtaButton } from './CtaButton';
export function Volumes() {
  return <section id="volumes" className="w-full bg-stone-50 px-5 py-20 sm:py-28" data-id="element-216" data-mp="1lw1z651zcuru">
      <div className="mx-auto max-w-5xl" data-id="element-217" data-mp="184oh6vjq04yx">
        <h2 className="text-center font-serif text-[1.6rem] font-black leading-tight tracking-tight text-stone-900 sm:text-4xl" data-id="element-218" data-mp="185q3xxa3mfwh">
          Los 12 Volúmenes de INGLÉS LISTO™
        </h2>

        <ol className="mt-12 grid gap-x-10 sm:grid-cols-2 lg:grid-cols-3" data-id="element-219" data-mp="1zvks3qm7zzjk">
          {volumes.map(volume => <li key={volume.number} className="flex gap-4 border-t border-stone-200 py-6" data-id="element-220" data-mp="24s1thmifkael">
              <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-lg font-serif text-lg font-black ${volume.coverClass}`} aria-hidden="true" data-id="element-221" data-mp="1vt7q9dalgls2">
                {volume.number}
              </span>
              <div data-id="element-222" data-mp="kc7wsecig0wg">
                <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-stone-500" data-id="element-223" data-mp="3o86ochnzk2b8">
                  Volumen {volume.number}
                </p>
                <h3 className="mt-1 font-serif text-lg font-bold leading-snug text-stone-900" data-id="element-224" data-mp="3jamzkntnw751">
                  {volume.title}
                </h3>
                <p className="mt-1.5 text-sm leading-relaxed text-stone-600" data-id="element-225" data-mp="3t7j6wq7tqn80">
                  {volume.text}
                </p>
              </div>
            </li>)}
        </ol>

        <div className="mt-10 text-center" data-id="element-226" data-mp="62juaw9yc1na">
          <CtaButton href="#offer" data-id="element-227" data-mp="61sa0hlt1qcb" />
        </div>
      </div>
    </section>;
}